import { SET_LOB_PRODUCT_TOGGLE } from "constants-lib/actionTypes"

export const setProductLobToggle = (data) => ({
  type: SET_LOB_PRODUCT_TOGGLE,
  payload: data,
})
